var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { style: _vm.dependenciesComponentsStyleList }, [
    _c("span", {
      staticClass: "ui-icon-circle-close error--text mx-auto mb-3 d-block",
      style: _vm.canceledIconStyleList,
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-body-1 text--text text-center" },
      [_vm._t("club-error-html")],
      2
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "b-button b-button_light mb-4 mt-6",
        class: _vm.buttonDeviceClassList,
        attrs: { type: "button" },
        on: { click: _vm.handleReturnFromErrorView },
      },
      [
        _c("span", { staticClass: "text-button primary--text" }, [
          _vm._v("\n      Вернуться\n    "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }